import { useUserOrders } from 'hooks/use-user-orders';
import { useAuthContext } from 'state/auth';
import { useFlag } from 'state/launchdarkly';
import { OrderStatus } from 'state/order';
import { LaunchDarklyFlag } from 'utils/launchdarkly';

/**
 * Checks total number of refunds that a user has and determines
 * whether or not the user is allowed to initiate a refund.
 */
export const useCheckUserRefundsCount = () => {
  const { user } = useAuthContext();
  const { loading, orders } = useUserOrders(user, {
    orderStatuses: [OrderStatus.REFUND_SUCCESSFUL, OrderStatus.REFUND_REQUESTED],
  });

  const maxFullRefundCount = useFlag(LaunchDarklyFlag.MAX_CUSTOMER_INITIATED_FULL_REFUND_COUNT);
  const maxPartialRefundCount = useFlag(
    LaunchDarklyFlag.MAX_CUSTOMER_INITIATED_PARTIAL_REFUND_COUNT
  );

  const countFullRefunds = orders.reduce(
    (count, order) => (order?.order?.refund ? count + 1 : count),
    0
  );

  const countPartialRefunds = orders.length - countFullRefunds;

  const areTotalRefundsWithinLimit =
    countFullRefunds < maxFullRefundCount && countPartialRefunds < maxPartialRefundCount;

  const orderRefunded = countFullRefunds || countPartialRefunds;

  return {
    loading,
    areTotalRefundsWithinLimit,
    orderRefunded,
  };
};
